<div class="is-admin">
  <app-checkbox
    (click)="changeIsAdminState()"
    [value]="entity"
    [checked]="entity.isAdmin"
    [label]="'Admin'"
  ></app-checkbox>
</div>

<div class="inputs">
  <div>
    <label [class.is-edit]="isEdit">{{ 'Username' | translate }}</label>
    <div [class.is-edit]="isEdit" class="username-two-factor">
      <input
        [class.has-error]="hasErrors('username')"
        class="txt-input"
        (change)="onChangeInput($event, 'username')"
        [value]="entity.username"
        [disabled]="isEdit"
      />
      <latitude-toggle
        [label]="'Two-Factor Authentication' | translate"
        [checked]="entity.twoFactorAuth"
        (change)="changeTwoFactorAuthState($event)"
      >
      </latitude-toggle>
    </div>
    <p class="error" *ngFor="let error of getErrorsByField('username')">
      {{ error | translate }}
    </p>
  </div>

  <div class="email">
    <label>{{ 'Email' | translate }}</label>
    <input
      class="txt-input"
      [class.has-error]="hasErrors('email')"
      (change)="onChangeInput($event, 'email')"
      [value]="entity.email"
    />
    <p class="error" *ngFor="let error of getErrorsByField('email')">
      {{ error | translate }}
    </p>
  </div>

  <div class="password" *ngIf="!isEdit">
    <label>{{ 'Temporary password' | translate }}</label>
    <div [class.is-edit]="true">
      <input
        class="txt-input"
        [class.has-error]="hasErrors('password')"
        [value]="entity.password"
        [disabled]="true"
      />
      <p class="copy" (click)="copyPassword($event)">
        {{ 'Copy to clipboard' | translate }}
      </p>
    </div>
    <p class="error" *ngFor="let error of getErrorsByField('password')">
      {{ error | translate }}
    </p>
  </div>
</div>

<div class="locations" [class.disabled]="entity.isAdmin">
  <label>{{ 'Territory Access Permissions' | translate }}</label>
  <div class="search" [class.has-error]="hasErrors('territories')">
    <div (click)="removeSearch()" class="close-icon"></div>
    <input
      [disabled]="entity.isAdmin"
      #searchInput
      type="text"
      [placeholder]="'Search territories to add' | translate"
      (keyup)="searchLocations($event)"
      (focusin)="filterFoundLocations(locationResults)"
    />
    <div class="search-icon"></div>
  </div>
  <p class="error" *ngFor="let error of getErrorsByField('territories')">
    {{ error | translate }}
  </p>
  <div class="search-results" *ngIf="inputValue">
    <div class="custom-scrollbar">
      <div
        (click)="addLocation(loc)"
        class="row"
        *ngFor="let loc of locationResults"
      >
        <p>
          <span
            >{{ loc.name }}
            <span *ngIf="loc?.province" class="province"
              >({{ loc?.province }})</span
            ></span
          >
          <span class="territory">{{
            getTerritory(loc.terrunit) | translate
          }}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="selected-locs">
    <p class="no-loc-selected" *ngIf="selectedLocations.length === 0">
      {{ 'No territory access permissions yet' | translate }}
    </p>
    <div class="territory" *ngFor="let terr of orderedSelectedLocByTerr">
      <p class="territory-label">
        {{ terr.name | translate }}: {{ terr.locs.length }}
      </p>
      <div class="custom-scrollbar locs-by-territory">
        <app-button
          *ngFor="let loc of terr.locs"
          [label]="loc.name"
          (onClick)="removeLocation(loc)"
          class="selected-loc"
        ></app-button>
      </div>
    </div>
  </div>
</div>

<div class="delete-wrapper" *ngIf="isEdit && !isMe()">
  <div
    [class.confirm]="showConfirmDelete"
    (click)="deleteUser()"
    class="delete"
  >
    <div class="delete-btn"></div>
    <p>{{ 'Delete the user definitively' | translate }}</p>
  </div>
  <app-button
    (onClick)="backDeleteUser()"
    [label]="'Go back'"
    [secondary]="true"
  ></app-button>
</div>
